import { defineComponent as o, openBlock as n, createBlock as p, unref as l, mergeProps as m, withCtx as c, createElementVNode as a } from "vue";
import { RevIcon as h } from "@ds/components/Icon";
const f = /* @__PURE__ */ o({
  name: "IconSearchWithSparkle",
  __name: "IconSearchWithSparkle",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const r = t;
    return (i, e) => (n(), p(l(h), m(r, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        a("path", { d: "M14.996 5a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 1.5 0v2m.969 2.516a.75.75 0 1 1 0-1.5h2a.75.75 0 0 1 0 1.5h-2m-5.508 0a.75.75 0 0 1 0-1.5h2a.75.75 0 1 1 0 1.5h-2m4.539 3.016a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 1.5 0v2" }, null, -1),
        a("path", { d: "M21.53 20.47a.75.75 0 1 1-1.06 1.06l-5.546-5.545A7.75 7.75 0 1 1 10 2.25a.75.75 0 0 1 0 1.5 6.25 6.25 0 1 0 5.817 8.54.75.75 0 1 1 1.396.55 7.7 7.7 0 0 1-1.228 2.084l5.545 5.546" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
